import React, { createContext, useContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { getInitialState } from './reducer';
import { reducer } from './reducer';

export const StateContext = createContext([{}]);

export const StateProvider = ({ client, isPreview, children }) => {
	const initialState = getInitialState(client || 'AOL', isPreview);

	return (
		<StateContext.Provider value={useReducer(reducer, initialState)}>
			{children}
		</StateContext.Provider>
	);
};


StateProvider.propTypes = {
	client: PropTypes.string,
	isPreview: PropTypes.bool,
	children: PropTypes.any
}

export const useStateValue = () => useContext(StateContext);
